module.exports = __webpack_public_path__ + "img/kolase2.3446c776.jpg";